import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  props: [
    'data',
    'options',
    'chart'
  ],
  mounted() {
  // TEMPORARILY COMMENTED OUT, MAY USE LATER?
    if (this.data) {
      // create glow effect on line
      let draw = Chart.controllers.line.prototype.draw;
      Chart.controllers.line.prototype.draw = function () {
        let chart = this.chart;
        let ctx = chart.ctx;
        let _stroke = ctx.stroke;
        ctx.stroke = function () {
          ctx.save();
          ctx.shadowColor = ctx.strokeStyle;
          ctx.shadowBlur = 5;
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;
          _stroke.apply(this, arguments);
          ctx.restore();
        };
        draw.apply(this, arguments);
        ctx.stroke = _stroke;
      };

      // create gradient fill under line
      let gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
      gradient.addColorStop(0, this.chartGradientColor); // line color
      gradient.addColorStop(.4, 'rgba(50, 65, 82, 0)'); // chart background color
      this.data.datasets = [
        {
          ...this.data.datasets[0],
          backgroundColor: gradient
        }
      ]

    this.renderChart(this.data, this.options);
    }
  },
  computed: {
    chartGradientColor() {
      if (this.chart === 'mra') {
        return 'rgba(122, 73, 165, 0.25)';
      } else if (this.chart === 'mlr') {
        return 'rgba(30, 136, 229, 0.25)';
      } else if (this.chart === 'admissions' || this.chart === 'admissions costs' || this.chart === 'admits per 1000') {
        return 'rgba(236, 64, 122, 0.25)';
      } else if (this.chart === 'brand rx' || this.chart === 'brand rx costs') {
        return 'rgba(255, 161, 102, 0.25)';
      } else if (this.chart === 'er visits' || this.chart === 'er costs'|| this.chart === 'er visits per 1000') {
        return 'rgba( 144, 190, 109, 0.25)';
       
      } else if (this.chart === 'outpatients' || this.chart === 'outpatient costs' || this.chart === 'outpatient visits') {
        return 'rgba(119, 104, 174, 0.25)';
      }  else if (this.chart === 'observations per 1000' || this.chart === 'observations' ) {
        return 'rgba(249, 132, 74, 0.25)';
      } else if (this.chart === 'inpatient' ) {
        return 'rgba(87, 117, 144, 0.25)';
      } else if (this.chart === 'average stay' ) {
        return 'rgba(39, 125, 161, 0.25)';
      } else {
        return 'rgba(255, 255, 255, 0.25)';
      }
    }
  },
  watch: {
    async data() {
      // create gradient fill under both lines revenue and expenses
      if (this.chart === 'revExp') {
        let gradient1 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
        gradient1.addColorStop(0, 'rgba(102, 187, 106, .25)'); // line color
        gradient1.addColorStop(.4, 'rgba(50, 65, 82, 0)'); // chart background color
        let gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
        gradient2.addColorStop(0, 'rgba(255, 23, 69, .3)'); // line color
        gradient2.addColorStop(.4, 'rgba(50, 65, 82, 0)'); // chart background color
        this.data.datasets = [
          {
            ...this.data.datasets[0],
            fill: true,
            backgroundColor: gradient1
          },
          {
            ...this.data.datasets[1],
            fill: true,
            backgroundColor: gradient2
          }
        ]
      } else {
        let gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
        gradient.addColorStop(0, this.chartGradientColor); // line color
        gradient.addColorStop(.4, 'rgba(50, 65, 82, 0)'); // chart background color
        this.data.datasets = [
          {
            ...this.data.datasets[0],
            backgroundColor: gradient
          }
        ]
      }
      this.renderChart(this.data, this.options);
    },
  },
};